import { stpFutureValue } from "../../engine/calculations";

const fvStpConfig = {
  key: "fv-stp",
  title: "Future Value of STP",
  category: "Growth",
  description: "Model a Systematic Transfer Plan: money moves out of one fund into another every month.",
  fields: [
    { key: "sourceCorpus", label: "Source corpus (e.g. debt/liquid fund)", type: "currency", default: 10_00_000, min: 1000, max: 10_00_00_000 },
    { key: "sourceRate", label: "Source fund return", type: "percent", default: 7, min: 0, max: 20, assumptionKey: "debtReturn" },
    { key: "targetRate", label: "Target fund return", type: "percent", default: 12, min: 0, max: 30, assumptionKey: "equityReturn" },
    { key: "monthlyTransfer", label: "Monthly transfer amount", type: "currency", default: 25_000, min: 500, max: 10_00_000 },
    { key: "months", label: "Transfer period (months)", type: "number", default: 36, min: 1, max: 480 },
  ],
  chart: {
    type: "line",
    xKey: "month",
    series: [
      { key: "source", label: "Source balance", colorVar: "--muted" },
      { key: "target", label: "Target balance", colorVar: "--gold" },
    ],
  },
  compute(values) {
    const sourceCorpus = Number(values.sourceCorpus) || 0;
    const sourceRate = (Number(values.sourceRate) || 0) / 100;
    const targetRate = (Number(values.targetRate) || 0) / 100;
    const monthlyTransfer = Number(values.monthlyTransfer) || 0;
    const months = Math.round(Number(values.months) || 0);

    const result = stpFutureValue(sourceCorpus, sourceRate, targetRate, monthlyTransfer, months);

    const series = result.schedule.filter((row) => row.month % Math.max(Math.round(months / 40), 1) === 0 || row.month === months);

    return {
      headline: { label: "Target fund value", value: result.finalTarget },
      extraHeadlines: [{ label: "Remaining source balance", value: result.finalSource }],
      breakdown: [
        { label: "Starting source corpus", value: sourceCorpus },
        { label: "Monthly transfer × months", value: monthlyTransfer * months },
        { label: "Combined value (source + target)", value: result.finalSource + result.finalTarget },
      ],
      series,
    };
  },
};

export default fvStpConfig;
